import { Path, Svg } from 'react-native-svg';

import { type IconProps } from '../types';

export const IconRemove = (props: IconProps) => {
  const { size = 16, color, ...otherProps } = props;

  return (
    <Svg
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      color={color ?? 'black'}
      {...otherProps}
    >
      <Path fill="currentColor" d="M19 13.1H5v-2h14v2Z" />
    </Svg>
  );
};
